import React from 'react';
import PropTypes from 'prop-types';
import LearnosityText from '../library/LearnosityText';
import { convertQuestionNumberToLetter } from './utils';

const CustomDistractorRationale = (props) => {
  const { correctOptions, selectedOptions, customDistractors } = props;
  if (!selectedOptions?.length || !correctOptions?.length) {
    return null;
  }

  return selectedOptions.toSorted().map((optionNumber) => (
    <div
      className={`lrn_distractor_rationale_list lrn_distractor_rationale_${
        correctOptions.includes(optionNumber) ? 'correct' : 'incorrect'
      }`}
      key={optionNumber}
    >
      <div className="lrn_distractor_rationale_list_title">
        {correctOptions.includes(optionNumber) ? 'Correct' : 'Incorrect'}
      </div>
      <div className="lrn_distractor_rationale">
        <div className="lrn_validation_stem_numeration">
          {convertQuestionNumberToLetter(optionNumber)}
        </div>
        <div className="lrn_distractor_rationale_content">
          <LearnosityText text={customDistractors[optionNumber]} />
        </div>
      </div>
    </div>
  ));
};

CustomDistractorRationale.propTypes = {
  correctOptions: PropTypes.array.isRequired,
  selectedOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  customDistractors: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default CustomDistractorRationale;
